"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = StatsStackOverflow;
const React = require("react");
const StackOverflowService_1 = require("../../scripts/services/StackOverflowService");
const StatsStackExchange_1 = require("./StatsStackExchange");
function StatsStackOverflow({ reputation = 1863, answerCount = 0 }) {
    return (React.createElement(StatsStackExchange_1.default, { factory: () => new StackOverflowService_1.StackOverflowService({ reputation, answerCount }), techName: "stackoverflow", url: "https://stackoverflow.com/users/470214/fabasoad", icon: "\uD83C\uDFC6" }));
}
